import { useDoesUserHavePermission } from "../../../hooks/permissions";
import { useFetchClientNotesList } from "../../../hooks/queries/note";
import { UserPermisions } from "../../../utils/types/user";
import {
    formatAiWriterDateOfService,
    getAiWriterPreviousNoteTypes,
    isAiSessionNotesEnabled,
} from "../helpers/aiSessionNotes";
import { ISessionNote, NoteStatus, Source } from "../types/notes.types";

export function useAiWriterContinuityNotes(note: ISessionNote) {
    const canUseAi = useDoesUserHavePermission([
        UserPermisions.CLIENT_INFO_NOTES_AI_REVIEW,
    ]);
    const clientId = note.client?.client_id ?? "";
    const providerId = note.provider?.provider_id ?? "";
    const beforeDate = formatAiWriterDateOfService(note.date_of_service);
    const isEligibleDraft =
        note.note_status === NoteStatus.DRAFT &&
        note.source !== Source.MANUAL &&
        note.is_archived !== true;

    return useFetchClientNotesList(
        clientId,
        {
            type: getAiWriterPreviousNoteTypes(note.type),
            load_previous_notes: true,
            provider_id: providerId,
            before_date: beforeDate,
            limit: 1,
            status: [NoteStatus.PENDING_CODE_REVIEW, NoteStatus.CODED],
        },
        isAiSessionNotesEnabled() &&
            canUseAi &&
            isEligibleDraft &&
            Boolean(clientId && providerId && beforeDate)
    );
}
